import React from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import Form from "../../components/common/Forms/Form";

const ManuaisAssistenciasForm = (props) => {
  const { form, onSelectManual } = props;

  return (
    <>
      <Form
        form={form}
        formId="condicoes-gerais"
        initialValues={{
          produto: "",
          ano: "",
          versao: "",
          manualAssistenciaLink: "",
        }}
        validationSchema={() => ({
          produto: Yup.string(),
          ano: Yup.number(),
          versao: Yup.string(),
          manualAssistenciaLink: Yup.string(),
        })}
        formProps={props}
        onSubmit={onSelectManual}
      />
    </>
  );
};

ManuaisAssistenciasForm.propTypes = {
  form: PropTypes.elementType.isRequired,
  onSelectManual: PropTypes.func.isRequired,
};

export default ManuaisAssistenciasForm;
